<template>
	<v-sheet elevation="0">
		<CommonFlame :title="'チーム編集 | ' + this.department.name" class="ma-2">
			<template v-slot:app-bar-btn>
				<v-btn color="primary" @click="openAddTeamDialog"
					><v-icon>mdi-plus</v-icon>チーム追加</v-btn
				>
			</template>
			<v-row no-gutters v-if="teams.length > 0">
				<v-col v-for="(team, index) in teams" :key="team.id" lg="3" md="4" sm="6" class="pa-2">
					<v-card>
						<v-card-title>
							<p class="pointer" @click="openEditDialog(team)">{{ team.name }}</p>
							<v-spacer></v-spacer>
							<!-- toggle switch for open detail -->
							<v-btn fab color="primary" small @click="toggleDetail(index)">
								<v-icon>{{
									detailOpen[index] ? "mdi-chevron-up" : "mdi-chevron-down"
								}}</v-icon></v-btn
							>
						</v-card-title>
						<v-divider v-if="detailOpen[index] == true"></v-divider>
						<v-card-text v-if="detailOpen[index] == true">
							<!-- <v-btn @click="removeTeam(team)"> チームの削除 </v-btn> -->
							<v-list v-if="team.users.length > 0">
								<v-list-item v-for="(user, index) in team.users" :key="index">
									<v-list-item-content>
										{{ user.last_name }} {{ user.first_name }}
									</v-list-item-content>
									<v-list-item-action>
										<v-btn fab color="primary" small @click="removeMember(team, user)">
											<v-icon>mdi-delete</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
							<v-alert v-else :value="true" color="warning" icon="mdi-alert">
								チームメンバーがいません。
							</v-alert>
						</v-card-text>
						<v-divider v-if="detailOpen[index] == true"></v-divider>
						<v-card-actions v-if="detailOpen[index] == true">
							<v-select
								:ref="'sheet-' + index"
								:items="users"
								v-model="selectedMember[index]"
								item-value="value"
								:item-text="getUserName"
								label="追加するメンバーを選択してください。"
								clearable
								multiple
								return-object
							/>
							<v-btn
								color="primary"
								@click="addMember(team, index)"
								:disabled="!selectedMember[index]"
							>
								追加
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</CommonFlame>
		<CreateTeamDialog
			:department="department"
			@teamCreated="fetchTeamsAndUsers"
			ref="addTeamDialog"
		/>
		<editTeamDialog @teamNameUpdated="fetchTeamsAndUsers" ref="editTeamDialog" />
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import CreateTeamDialog from "./components/CreateTeamDialog.vue"
import editTeamDialog from "./components/EditTeamDialog.vue"
export default {
	name: "TeamPage",
	components: {
		CommonFlame,
		CreateTeamDialog,
		editTeamDialog,
	},
	data() {
		return {
			teams: [],
			users: [],
			selectedMember: [],
			department: { name: "" },
			detailOpen: [],
		}
	},
	created() {
		this.fetchTeamsAndUsers()
	},
	methods: {
		toggleDetail(index) {
			if (this.detailOpen[index]) {
				let newArray = this.detailOpen
				this.detailOpen = []
				newArray[index] = false
				this.detailOpen = newArray
				console.log(this.detailOpen)
			} else {
				let newArray = this.detailOpen
				this.detailOpen = []
				newArray[index] = true
				this.detailOpen = newArray
				console.log(this.detailOpen)
			}
		},
		getUserName(item) {
			return item.last_name + " " + item.first_name
		},
		fetchTeamsAndUsers() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/teams/" + this.$route.params.id, { headers })
				.then((response) => {
					this.teams = response.data.teams
					this.department = response.data.department
					this.users = response.data.users
					this.detailOpen = new Array(this.teams.length).fill(false)
					console.log(response.data)
				})
				.catch((error) => {
					console.log(error)
				})
		},
		clearSheet(index) {
			this.selectedMember = []
		},
		openEditDialog(team) {
			this.$refs.editTeamDialog.open(team)
		},
		addMember(team, index) {
			if (!this.selectedMember[index]) {
				this.clearSheet(index)
				return
			}
			const members = this.selectedMember[index]
			if (members.length > 0) {
				// team.users.push(members)
				let newMemberIds = []
				// 重複しているユーザーを除外
				for (let i = 0; i < members.length; i++) {
					const hasObjectWithSameId = team.users.some((obj) => obj.id === members[i].id)
					if (!hasObjectWithSameId) {
						team.users.push(members[i])
						newMemberIds.push(members[i].id)
					}
				}
				// 新しいユーザーがない場合は処理を終了
				if (newMemberIds.length === 0) {
					this.clearSheet(index)
					return
				}
				// 重複しているユーザーを除外したユーザーを登録
				const headers = authenticate.setHeader()
				axios
					.post(
						"/erp/v1/teams/members",
						{
							user_ids: newMemberIds,
							team_id: team.id,
						},
						{
							headers,
						}
					)
					.then((response) => {
						this.clearSheet(index)
						this.$store.dispatch("setFlash", {
							text: response.data.message,
							type: "notice",
						})
					})
					.catch((error) => {
						console.log(error)
						errorHandling.errorResponse(err)
					})
			}
		},
		removeMember(team, member) {
			const index = team.users.indexOf(member)
			if (index !== -1) {
				team.users.splice(index, 1)
				const headers = authenticate.setHeader()
				axios
					.delete("/erp/v1/teams/members/" + member.id + "?team_id=" + team.id, {
						headers,
					})
					.then((response) => {
						this.$store.dispatch("setFlash", {
							text: response.data.message,
							type: "notice",
						})
						this.fetchTeamsAndUsers()
					})
					.catch((error) => {
						console.log(error)
						errorHandling.errorResponse(err)
					})
			}
		},
		openAddTeamDialog() {
			this.$refs.addTeamDialog.open()
		},
	},
}
</script>

<style scoped>
.team-page {
	padding: 20px;
}
</style>
